module.exports = __webpack_public_path__ + "img/zeroEight.63af3db6.png";